//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    type: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      weixinObj: null,
    };
  },
  mounted() {
    const href = encodeURI(
      `https://www.gelonghui.com${location.pathname}?reform=${location.href}`
    );
    this.weixinObj = new WxLogin({
      id: 'qrbox',
      appid: 'wxfd29938cea1c1b3d',
      scope: 'snsapi_login',
      redirect_uri: href,
    });
  },
  beforeDestroy() {
    this.weixinObj = null;
  },
  methods: {
    /**
     * @description 修改弹窗页面
     */
    changePhone() {
      this.$emit('changePage', {
        page: 'base',
      });
    },
  },
};
